import styled from "styled-components";
import { useCloseWithEsc } from "../../helpers/hooks";
import { Box } from "../../styledCpns/Layout";
import { colors } from "../../theme";

export default function Modal({ standard, contentClass, close, children }) {
  useCloseWithEsc(close);
  return (
    <ModalLayout>
      <Box
        className="full-w full-h"
        bgColor="rgba(0, 0, 0, .6)"
        onClick={close}
      />
      {standard || contentClass ? (
        <ModalContent className={contentClass || ""}>{children}</ModalContent>
      ) : (
        children
      )}
    </ModalLayout>
  );
}

export const ModalLayout = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  & > div:nth-child(2) {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
  }
`;

export const ModalContent = styled.div`
  width: 90vw;
  height: 90vh;
  border-radius: 0.625rem;
  background-color: ${colors.cardBg2};
  box-shadow: 0 0 3px white;
  @media (min-width: 440px) {
    width: 398.45px;
  }
  @media (min-width: 610px) {
    width: 586px;
  }
  @media (min-width: 769px) {
    width: 722px;
  }
  @media (min-width: 1025px) {
    height: 85vh;
    width: 944px;
  }
`;
